/* eslint-disable */
import * as currentEmployee from './currentEmployee';

export default {
  currentEmployee,
};
